export interface AuthUsernameSuccessResponse {
  data: {
    _type: string;
    id: string;
    access_token: string;
    roles: string[];
    expires: Date;
    mixpanel_id: string;
  };
}

export const isAuthUsernameSuccessResponse = (
  response: any
): response is AuthUsernameSuccessResponse => {
  return response.data && response.data._type === "auth";
};
